import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { Visitor } from 'src/features/visitor/types';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/visitors/visitor/:visitorId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    visitorId: string;
}
const queryFn = ({ parkingId, visitorId, ...params }: DTO): Promise<Visitor> => {
    return axios.get(formatResourcePath(RESOURCE, { visitorId, parkingId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetVisitor };
